import React from 'react';
import { Button, LoadingButton, ModalHeader, ModalBody, ModalFooter, Typography, } from '@one-thd/sui-atomic-components';
import { CardInfo } from '../../shared/card/card-info';
export const StopRemotePurchaseModal = ({ hideModal, onConfirmation, card, isLoading, onlyPhoneAuth, hasBenefit, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalHeader, { onClose: hideModal },
            "Stop ",
            onlyPhoneAuth ? 'Phone' : 'Remote',
            " Purchase Approvals for This Card"),
        React.createElement(ModalBody, null,
            React.createElement(Typography, { variant: "body-base", weight: "bold" }, onlyPhoneAuth
                ? ' Are you sure you want to stop phone purchase approvals for this card?'
                : 'Are you sure you want to stop all remote purchase approvals for this card?'),
            React.createElement("div", { className: "sui-my-6" },
                React.createElement(CardInfo, { card: card })),
            onlyPhoneAuth ? (React.createElement(Typography, null, "You\u2019ll no longer be able to make in-store purchases with this card using Home Depot Pass.")) : (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "sui-mb-3" },
                    React.createElement(Typography, null, "You'll no longer be able to do the following from this card:")),
                React.createElement(Typography, null,
                    React.createElement("ul", { className: "sui-list-disc sui-ml-6" },
                        React.createElement("li", null, "Approve in-store purchases via Phone Sale"),
                        React.createElement("li", null, "Approve in-store purchases via Text2Confirm"),
                        hasBenefit && (React.createElement("li", null, "Assign Pro Allowances and use existing Pro Allowances"))))))),
        React.createElement(ModalFooter, { position: "end" },
            React.createElement("div", { className: "sui-flex sui-gap-4 sm:sui-gap-4 sui-flex-col-reverse sui-w-full sm:sui-flex-row sm:sui-w-auto" },
                React.createElement(Button, { variant: "secondary", onClick: hideModal }, "No"),
                React.createElement(LoadingButton, { loading: isLoading, variant: "primary", onClick: onConfirmation }, "Yes, Stop for This Card")))));
};
StopRemotePurchaseModal.displayName = 'StopRemotePurchaseModal';
